// src/pages/MaintenancePage.js

import React from 'react';
import PageTransitionWrapper from '../../components/layout/PageTransitionWrapper';
import { FaTools, FaClock, FaCalendarCheck, FaArrowLeft } from 'react-icons/fa'; // Import FaArrowLeft

const MaintenancePage = () => {
    const estimatedEndTime = 'Secepat Mungkin';

    // Fungsi untuk kembali ke halaman sebelumnya
    const handleGoBack = () => {
        // Menggunakan window.history.back() untuk kembali ke halaman sebelumnya di riwayat browser
        window.history.back();
    };

    return (
        <PageTransitionWrapper>
            {/* Mengatur layout agar tetap di bagian atas (items-start) */}
            <div className="flex items-start justify-center pt-8 pb-8">
                <div className="max-w-3xl w-full bg-white rounded-xl shadow-2xl p-8 sm:p-10 text-center border-t-8 border-yellow-500 transform transition-all duration-500 hover:shadow-3xl">

                    {/* Header dan Logo */}
                    <div className="mb-8">
                        <FaTools className="text-7xl text-yellow-600 mx-auto mb-4 animate-spin-slow" />
                        <h1 className="text-4xl font-extrabold text-gray-900">
                            MAINTENANCE MODE
                        </h1>
                        <p className="text-xl text-gray-600 mt-2">
                            Kami sedang melakukan pembaruan sistem penting.
                        </p>
                    </div>

                    {/* Detail Pesan */}
                    <div className="space-y-6 text-left">

                        <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200 shadow-inner">
                            <h2 className="text-lg font-bold text-yellow-700 mb-2 flex items-center">
                                <FaClock className="mr-2 text-xl" />
                                Estimasi Waktu Berakhir
                            </h2>
                            <p className="text-xl font-extrabold text-yellow-800">
                                {estimatedEndTime}
                            </p>
                            <p className="text-sm text-gray-600 mt-1">
                                Mohon maaf atas ketidaknyamanan ini. Kami berusaha agar situs segera kembali normal.
                            </p>
                        </div>

                        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                            <h2 className="text-lg font-bold text-blue-700 mb-2 flex items-center">
                                <FaCalendarCheck className="mr-2 text-xl" />
                                Apa yang sedang dilakukan?
                            </h2>
                            <p className="text-gray-700">
                                Kami sedang meningkatkan keamanan dan performa aplikasi untuk memberikan pengalaman yang lebih baik bagi seluruh jemaat.
                            </p>
                        </div>

                    </div>

                    {/* Tombol Kembali (Pengganti Kontak) */}
                    <div className="mt-8 pt-4 border-t border-gray-200">
                        <button
                            onClick={handleGoBack}
                            className="w-full sm:w-auto px-6 py-3 bg-gray-600 text-white font-semibold rounded-lg shadow-md hover:bg-gray-700 transition duration-200 flex items-center justify-center mx-auto"
                        >
                            <FaArrowLeft className="mr-2" />
                            Kembali ke Halaman Sebelumnya
                        </button>
                    </div>

                </div>
            </div>
        </PageTransitionWrapper>
    );
};

export default MaintenancePage;